import { createContext } from "react";

import type { useAccessApiKeys } from "../hooks/useAccessApiKeys";
import type { useAccessUsers } from "../hooks/useAccessUsers";
import type { usePolicies } from "../hooks/usePolicies";
import type { useRoles } from "../hooks/useRoles";

/**
 * Contexts for the shared "Access & permissions" data (see `AccessDataProvider`). Each entity gets its own
 * context so consumers re-render only when their slice changes. The value shapes mirror the existing data
 * hooks exactly (`ReturnType<...>`) — the provider just hoists those hooks to a single instance. Reader hooks
 * live in `hooks/useAccessData.ts` (kept separate so this stays component-free for fast refresh).
 */

export type RolesData = ReturnType<typeof useRoles>;
export type PoliciesData = ReturnType<typeof usePolicies>;
export type UsersData = ReturnType<typeof useAccessUsers>;
export type ApiKeysData = ReturnType<typeof useAccessApiKeys>;

export const RolesContext = createContext<RolesData | null>(null);
export const PoliciesContext = createContext<PoliciesData | null>(null);
export const UsersContext = createContext<UsersData | null>(null);
export const ApiKeysContext = createContext<ApiKeysData | null>(null);
